import script from "./AddProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProduct.vue?vue&type=script&lang=ts&setup=true"

import "./AddProduct.vue?vue&type=style&index=0&id=0c95b904&lang=scss"
import "./AddProduct.vue?vue&type=style&index=1&id=0c95b904&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c95b904"]])

export default __exports__